import React from 'react';
import { Button, Box, Popover, PopoverTrigger, PopoverContent, Icon, Flex, } from '@spothero/ui';
import IconUser from '@spothero/icons/user';
import IconMenu from '@spothero/icons/menu';
import { LoginState } from './LoginState';
import { LinkList } from './LinkList';
export const SearchHeaderDropdown = () => {
    const [isOpen, setIsOpen] = React.useState(false);
    const open = () => setIsOpen(!isOpen);
    const close = () => setIsOpen(false);
    return (<Flex position="relative">
            <Popover returnFocusOnClose={false} isOpen={isOpen} onClose={close} closeOnBlur placement="top-start">
                <PopoverTrigger>
                    <Button aria-label="Menu" onClick={isOpen ? close : open} variant="tertiary" padding="4" borderRadius="2" color="black">
                        <Icon as={IconUser} height="6" width="6"/>
                        <Icon as={IconMenu} height="6" width="6"/>
                    </Button>
                </PopoverTrigger>
                <PopoverContent hideCloseButton hideArrow placement="top-start">
                    <LoginState />
                    <Box marginY="4" borderTop="1px solid" borderColor="gray.200"/>
                    <LinkList />
                </PopoverContent>
            </Popover>
        </Flex>);
};
